import {List} from 'immutable';
import type {QuestionSet as QuestionSetModelV1} from 'resources/GeneratedModels/QuestionSet/QuestionSetModel.v1';

export default function getQuestionDifficultiesFromQuestionSets(
  questionSets: List<QuestionSetModelV1>
): List<number> {
  return List(
    questionSets.flatMap((questionSet) =>
      questionSet.getQuestions().map((question) => question.getDifficulty())
    )
  );
}
